 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"ClaimPage~PortfolioPage~VeBalPage":"ClaimPage~PortfolioPage~VeBalPage","ClaimPage":"ClaimPage","CookiesPolicyPage":"CookiesPolicyPage","CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage~WalletConnectConnecto~591ccf73":"CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage~WalletConnectConnecto~591ccf73","CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage~WalletConnectConnector":"CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage~WalletConnectConnector","CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage":"CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage","CreatePoolPage":"CreatePoolPage","GetVeBalPage~HomePage~PoolPage~PortfolioPage~UnlockVeBalPage~VeBalPage":"GetVeBalPage~HomePage~PoolPage~PortfolioPage~UnlockVeBalPage~VeBalPage","GetVeBalPage":"GetVeBalPage","HomePage":"HomePage","PoolInvestPage":"PoolInvestPage","PoolPage~PoolWithdrawPage":"PoolPage~PoolWithdrawPage","PoolWithdrawPage":"PoolWithdrawPage","TradePage":"TradePage","WalletConnectConnector~WalletLinkConnector":"WalletConnectConnector~WalletLinkConnector","WalletConnectConnector":"WalletConnectConnector","WalletLinkConnector":"WalletLinkConnector","FaucetPage":"FaucetPage","PoolPage~VeBalPage":"PoolPage~VeBalPage","VeBalPage":"VeBalPage","PortfolioPage":"PortfolioPage","PoolPage":"PoolPage","UnlockVeBalPage":"UnlockVeBalPage","GnosisSafeConnector":"GnosisSafeConnector","MigratePoolPage":"MigratePoolPage","PrivacyPolicyPage":"PrivacyPolicyPage","TallyConnector":"TallyConnector","TermsOfUsePage":"TermsOfUsePage"}[chunkId]||chunkId) + "." + {"ClaimPage~PortfolioPage~VeBalPage":"a2b6aee8","ClaimPage":"cf56388c","CookiesPolicyPage":"bc3e1d8e","CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage~WalletConnectConnecto~591ccf73":"a4704f12","CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage~WalletConnectConnector":"c2f05bec","CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage":"10c05230","CreatePoolPage":"8b996a03","GetVeBalPage~HomePage~PoolPage~PortfolioPage~UnlockVeBalPage~VeBalPage":"6a473d13","GetVeBalPage":"9f41f65d","HomePage":"5ffcbaa4","PoolInvestPage":"1d43cf6f","PoolPage~PoolWithdrawPage":"e02b99ca","PoolWithdrawPage":"f13a49c6","TradePage":"c5ce30fa","WalletConnectConnector~WalletLinkConnector":"5910b658","WalletConnectConnector":"271a0073","WalletLinkConnector":"bb4402b9","FaucetPage":"cf77bbc3","PoolPage~VeBalPage":"79ab0e5f","VeBalPage":"6a2689f5","PortfolioPage":"cdf7a55a","PoolPage":"79d369a6","UnlockVeBalPage":"99852643","GnosisSafeConnector":"1cf043e7","MigratePoolPage":"c3ab5517","PrivacyPolicyPage":"48b15583","TallyConnector":"ec7f88f1","TermsOfUsePage":"c78ecc80"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"ClaimPage~PortfolioPage~VeBalPage":1,"ClaimPage":1,"CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage":1,"CreatePoolPage":1,"GetVeBalPage":1,"HomePage":1,"PoolInvestPage":1,"PoolWithdrawPage":1,"TradePage":1,"PoolPage~VeBalPage":1,"VeBalPage":1,"PortfolioPage":1,"PoolPage":1,"UnlockVeBalPage":1,"MigratePoolPage":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"ClaimPage~PortfolioPage~VeBalPage":"ClaimPage~PortfolioPage~VeBalPage","ClaimPage":"ClaimPage","CookiesPolicyPage":"CookiesPolicyPage","CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage~WalletConnectConnecto~591ccf73":"CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage~WalletConnectConnecto~591ccf73","CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage~WalletConnectConnector":"CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage~WalletConnectConnector","CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage":"CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage","CreatePoolPage":"CreatePoolPage","GetVeBalPage~HomePage~PoolPage~PortfolioPage~UnlockVeBalPage~VeBalPage":"GetVeBalPage~HomePage~PoolPage~PortfolioPage~UnlockVeBalPage~VeBalPage","GetVeBalPage":"GetVeBalPage","HomePage":"HomePage","PoolInvestPage":"PoolInvestPage","PoolPage~PoolWithdrawPage":"PoolPage~PoolWithdrawPage","PoolWithdrawPage":"PoolWithdrawPage","TradePage":"TradePage","WalletConnectConnector~WalletLinkConnector":"WalletConnectConnector~WalletLinkConnector","WalletConnectConnector":"WalletConnectConnector","WalletLinkConnector":"WalletLinkConnector","FaucetPage":"FaucetPage","PoolPage~VeBalPage":"PoolPage~VeBalPage","VeBalPage":"VeBalPage","PortfolioPage":"PortfolioPage","PoolPage":"PoolPage","UnlockVeBalPage":"UnlockVeBalPage","GnosisSafeConnector":"GnosisSafeConnector","MigratePoolPage":"MigratePoolPage","PrivacyPolicyPage":"PrivacyPolicyPage","TallyConnector":"TallyConnector","TermsOfUsePage":"TermsOfUsePage"}[chunkId]||chunkId) + "." + {"ClaimPage~PortfolioPage~VeBalPage":"74378818","ClaimPage":"6f64fe35","CookiesPolicyPage":"31d6cfe0","CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage~WalletConnectConnecto~591ccf73":"31d6cfe0","CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage~WalletConnectConnector":"31d6cfe0","CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage":"2a5b0994","CreatePoolPage":"fddc2c1a","GetVeBalPage~HomePage~PoolPage~PortfolioPage~UnlockVeBalPage~VeBalPage":"31d6cfe0","GetVeBalPage":"f11a56aa","HomePage":"cda13e98","PoolInvestPage":"0bbd2f44","PoolPage~PoolWithdrawPage":"31d6cfe0","PoolWithdrawPage":"118ac114","TradePage":"3f1e41d9","WalletConnectConnector~WalletLinkConnector":"31d6cfe0","WalletConnectConnector":"31d6cfe0","WalletLinkConnector":"31d6cfe0","FaucetPage":"31d6cfe0","PoolPage~VeBalPage":"f3b014e4","VeBalPage":"6956b24c","PortfolioPage":"50644c71","PoolPage":"b71f5451","UnlockVeBalPage":"f3b014e4","GnosisSafeConnector":"31d6cfe0","MigratePoolPage":"5242577c","PrivacyPolicyPage":"31d6cfe0","TallyConnector":"31d6cfe0","TermsOfUsePage":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
 	})();

 	webpackJsonpCallback([[], {}, 0, ["CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage~WalletConnectConnecto~591ccf73","CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage~WalletConnectConnector","CreatePoolPage~GetVeBalPage~HomePage~PoolInvestPage~PoolWithdrawPage~TradePage","GetVeBalPage~HomePage~PoolPage~PortfolioPage~UnlockVeBalPage~VeBalPage","HomePage","TradePage","PoolPage~VeBalPage","PoolPage~PoolWithdrawPage","PoolPage","ClaimPage~PortfolioPage~VeBalPage","PortfolioPage"]]);
 	return startupResult;
